import React from "react"

import * as styles from "./open-positions-list-block.module.css"
import OpenPosition from "../components/open-position"

const validColorCombination = combination => {
  const COLOR_COMBINATIONS = {
    "white-on-blue": "whiteOnBlue",
    "black-on-white": "blackOnWhite",
    "white-on-black": "whiteOnBlack",
  }

  return COLOR_COMBINATIONS[combination] || COLOR_COMBINATIONS["white-on-blue"]
}

const OpenPositionsListBlock = ({ data }) => {
  const colorCombination = validColorCombination(data.colorCombination)

  return (
    <div className={styles[colorCombination]} id="open_positions">
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: data.heading }} />
        <div className="columns">
          <div className="column is-offset-2-desktop mt-4">
            {data.openPositions.map(position => (
              <OpenPosition
                key={position.id}
                title={position.position}
                office={position.office}
                link={position.link}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpenPositionsListBlock
